import css from './ParameterTree.module.css'
import Tree from '@/shared/Tree'
import { ITreeGroup } from '@/shared/Tree/tree.types.ts'
import { IParameterGroup } from '@/pages/Parameters/parameters.types.ts'
import { memo, useMemo, useState } from 'react'
import useTreeExpandCtrl from '@/shared/Tree/ctrl/useTreeExpandCtrl.ts'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import useTreeSelectCtrl from '@/shared/Tree/ctrl/useTreeSelectCtrl.ts'
import defaultTreeGroupStyling from '@/shared/Tree/ui/DefaultTreeGroup/defaultTreeGroup.styling.ts'
import DefaultTreeGroup from '@/shared/Tree/ui/DefaultTreeGroup'
import MenuOptionCreate from '@/shared/Dropdowns/DropdownListItem/DropdownListItemCreate'
import MenuOptionDelete from '@/shared/Dropdowns/DropdownListItem/DropdownListItemDelete'
import MenuOptionEdit from '@/shared/Dropdowns/DropdownListItem/DropdownListItemEdit'
import parametersCUDServiceEvents from '@/pages/Parameters/services/ParametersCUDService/parametersCUDService.events.ts'
import useRequestDeleteParameterGroup from '@/pages/Parameters/hooks/useRequestDeleteParameterGroup.ts'
import useParameterGroups from '@/pages/Parameters/hooks/useParameterGroups.ts'

interface IProps {
  treeSelectCtrl: ReturnType<typeof useTreeSelectCtrl>
}

const ParameterGroupsTree = (props: IProps) => {
  const [isOpenExpand, setIsOpenExpand] = useState(false)
  const [clickedOnExpand, setClickedOnExpand] = useState(false)

  const parameterGroups = useParameterGroups()
  const handleGroupDelete = useRequestDeleteParameterGroup()

  const treeGroups: ITreeGroup<IParameterGroup, number>[] = useMemo(() => {
    if (!parameterGroups.length) return []

    return parameterGroups.map((g) => ({ id: g.id, parentId: g.parentId, data: g, type: 'folder' }))
  }, [parameterGroups])

  const expandCtrl = useTreeExpandCtrl(
    'parameter-groups-tree',
    isOpenExpand,
    treeGroups,
    [],
    setIsOpenExpand,
    clickedOnExpand,
    setClickedOnExpand
  )

  const renderGroup = (group: ITreeGroup<IParameterGroup, number>) => {
    const menuContent = (
      <>
        <MenuOptionEdit
          text="Редактировать"
          onClick={() => {
            parametersCUDServiceEvents.requestGroupUpdate(group.data.id)
          }}
        />
        <MenuOptionDelete text="Удалить" onClick={() => handleGroupDelete(group.data.id)} />
      </>
    )

    const createMenuContent = (
      <>
        <MenuOptionCreate
          text="Добавить группу"
          onClick={() => parametersCUDServiceEvents.requestGroupCreate(group.data.id)}
        />
        <MenuOptionCreate
          text="Добавить переменную"
          onClick={() => parametersCUDServiceEvents.requestParameterCreate(group.data.id)}
        />
      </>
    )

    return (
      <DefaultTreeGroup
        key={group.id}
        group={group.data}
        title={group.data.name}
        threeDotsMenuContent={menuContent}
        underCreateMenuContent={createMenuContent}
      />
    )
  }

  return (
    <div className={css.wrapperTree}>
      <div>
        <Tree
          leafs={[]}
          groups={treeGroups}
          renderGroup={renderGroup}
          renderLeaf={null}
          styling={{ groupClassname: defaultTreeGroupStyling.groupClassname }}
          expandCtrl={expandCtrl}
          selectCtrl={props.treeSelectCtrl}
          onClickGroup={(group: Record<string, any>) => props.treeSelectCtrl.handleSelect(group.id)}
        />
      </div>
      <div className={css.btnCreateGroup}>
        <CreateEntityButton
          fullWidth={true}
          type="default"
          onClick={() => parametersCUDServiceEvents.requestGroupCreate()}
          text="Создать группу"
        />
      </div>
    </div>
  )
}

export default memo(ParameterGroupsTree)
